import { Box, Button, HStack, Textarea, VStack } from '@chakra-ui/react';
import { AddIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import React, { ReactElement } from 'react';

type Props = {
  isDescriptionEditable: boolean;
  worksheetDescription: string;
  descriptionInputRef: React.RefObject<HTMLTextAreaElement>;
  onDescriptionChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onDescriptionClick: (() => void) | undefined;
  onResetDescription: () => void;
  onStopDescriptionEdit: () => void;
  onCreateDescription: () => void;
};

export const WorksheetDescription = ({
  isDescriptionEditable,
  worksheetDescription,
  descriptionInputRef,
  onDescriptionChange,
  onDescriptionClick,
  onResetDescription,
  onStopDescriptionEdit,
  onCreateDescription,
}: Props): ReactElement => {
  return (
    <Box width="100%" px={isDescriptionEditable || worksheetDescription ? '0' : '50px'} my="30px">
      {worksheetDescription || isDescriptionEditable ? (
        <VStack justifyContent="space-between" alignItems="flex-start">
          <HStack gap="10px" width="100%">
            <Textarea
              readOnly={!isDescriptionEditable}
              value={worksheetDescription}
              variant="subtle"
              width="100%"
              minWidth="100%"
              flexShrink={0}
              flexGrow={1}
              style={{
                fieldSizing: 'content',
              }}
              textStyle="body.m.regular"
              color={isDescriptionEditable ? 'text.primary' : 'text.quaternary'}
              resize="none"
              cursor={isDescriptionEditable ? 'text' : 'pointer'}
              padding="10px 5px"
              rows={1}
              onChange={onDescriptionChange}
              backgroundColor={isDescriptionEditable ? 'background.canvas' : 'transparent'}
              ref={descriptionInputRef}
              onClick={onDescriptionClick}
              _hover={{
                backgroundColor: !isDescriptionEditable ? 'background.primary' : undefined,
              }}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  onResetDescription();
                }
              }}
              onBlur={onStopDescriptionEdit}
            />
          </HStack>
        </VStack>
      ) : (
        <Button
          variant="tertiaryAction"
          onClick={onCreateDescription}
          textStyle="body.m.regular"
          display="flex"
          alignItems="center"
        >
          <NovaIcon icon={AddIcon} size="s" color="icon.info" aria-hidden />
          Beschreibung einfügen
        </Button>
      )}
    </Box>
  );
};
